import React from 'react';

function Home() {

  return (
    <div className='main-content'>
     <p>Home Page</p>
    </div>
  );
}

export default Home;